/* Tareef homepage sections: product tabs and product-row arrows. */
(() => {
  if (!customElements.get('tf-tabs')) {
    class TfTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.more = Array.from(this.querySelectorAll('[data-tf-more]'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
            event.preventDefault();
            const step = event.key === 'ArrowRight' ? 1 : -1;
            const next = (index + step + this.tabs.length) % this.tabs.length;
            this.select(next);
            this.tabs[next].focus();
          });
        });
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
        });
        this.panels.forEach((panel, i) => {
          panel.hidden = i !== index;
        });
        this.more.forEach((link, i) => {
          link.hidden = i !== index;
        });
      }
    }
    customElements.define('tf-tabs', TfTabs);
  }

  if (!customElements.get('tf-row')) {
    class TfRow extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-tf-track]');
        this.prev = this.querySelector('[data-tf-prev]');
        this.next = this.querySelector('[data-tf-next]');
        if (!this.track) return;
        this.prev?.addEventListener('click', () => this.scroll(-1));
        this.next?.addEventListener('click', () => this.scroll(1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        window.addEventListener('resize', () => this.update());
        this.update();
      }

      scroll(direction) {
        this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max;
      }
    }
    customElements.define('tf-row', TfRow);
  }
})();
